import { useSearchParams } from "next/navigation"

export default useSearchParams
